import { settings } from "app";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { Datagrid, FunctionField, List, ReferenceField, SimpleList, TextField, TextInput } from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { EducationType, MOBILE_BREAKPOINT } from "utils/constants";
import ChangeSpecialtyDialog from "./ChangeSpecialtyDialog";
import { accountRequests } from "api/accountApi";
import { studentRequests } from "api/studentApi";
import { MobileListRow } from "features/MobileListRow";

const ParticipantsPreparatoryList = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const renderActionButtons = record => (
    <SecuredComponent permission={permissions.canUpdatePreparatoryEducation}>
      <ChangeSpecialtyDialog record={record} />
    </SecuredComponent>
  );

  const participantsPreparatoryFilters = [
    <TextInput
      label="Факултетен номер"
      source="facultyNumber"
      style={{ width: 200 }}
      alwaysOn
    />,
  ];
  return (
    <List
      title="Обучавани в подготвителна година"
      filter={{ EducationType: EducationType.Preparatory }}
      filters={participantsPreparatoryFilters}
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                {
                  label: "Име",
                  value: (
                    <ReferenceField
                      source="userId"
                      reference={accountRequests.getUsersSelect()}
                      sortable={false}
                    >
                      <TextField source="firstName" />
                    </ReferenceField>
                  ),
                },
                {
                  label: "Презиме",
                  value: (
                    <ReferenceField
                      source="userId"
                      reference={accountRequests.getUsersSelect()}
                      sortable={false}
                    >
                      <TextField source="secondName" />
                    </ReferenceField>
                  ),
                },
                {
                  label: "Фамилия",
                  value: (
                    <ReferenceField
                      source="userId"
                      reference={accountRequests.getUsersSelect()}
                      sortable={false}
                    >
                      <TextField source="lastName" />
                    </ReferenceField>
                  ),
                },
              ]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Факултетен №", value: record?.facultyNumber }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                        sortable={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Подготвителна специалност",
                    value: (
                      <ReferenceField
                        source="preparatingForSpecialityId"
                        reference={studentRequests.getPreparatorySpecialitiesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Език на обучение",
                    value: (
                      <ReferenceField
                        source="instructionLanguageId"
                        reference={administrationRequests.getInstructionLanguagesSelect()}
                        sortable={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>{renderActionButtons(record)}</div>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <ReferenceField
            label="Име"
            source="userId"
            reference={accountRequests.getUsersSelect()}
            sortable={false}
          >
            <TextField source="firstName" />
          </ReferenceField>
          <ReferenceField
            label="Презиме"
            source="userId"
            reference={accountRequests.getUsersSelect()}
            sortable={false}
          >
            <TextField source="secondName" />
          </ReferenceField>
          <ReferenceField
            label="Фамилия"
            source="userId"
            reference={accountRequests.getUsersSelect()}
            sortable={false}
          >
            <TextField source="lastName" />
          </ReferenceField>
          <TextField
            source="facultyNumber"
            label="Факултетен №"
          />
          <ReferenceField
            label="Специалност"
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>

          <ReferenceField
            label="Подготвителна специалност"
            source="preparatingForSpecialityId"
            reference={studentRequests.getPreparatorySpecialitiesSelect()}
          >
            <TextField source="nameBg" />
          </ReferenceField>

          <ReferenceField
            source="instructionLanguageId"
            reference={administrationRequests.getInstructionLanguagesSelect()}
            label="Език на обучение"
          >
            <TextField source="name" />
          </ReferenceField>

          <FunctionField render={record => renderActionButtons(record)} />
        </Datagrid>
      )}
    </List>
  );
};

export default ParticipantsPreparatoryList;
